export const mapSupportMessage = (message: SupportTicketMessage): SupportRequestMessage => {
  let variant: SupportRequestMessageVariant = 'inline';

  if (message.title) {
    variant = message.author_type === 'support' ? 'highlighted_card' : 'card';
  }

  return {
    attachments: message.attachments,
    author: message.author_type,
    createdAt: message.created_at,
    id: String(message.id),
    text: message.text,
    title: message.title || undefined,
    variant,
  }
}

const mapSupportMessages = (messages: SupportTicketMessage[] = []): SupportRequestMessage[] => (
  [ ...messages ]
    .sort((firstMessage, secondMessage) => (
      new Date(secondMessage.created_at).getTime() - new Date(firstMessage.created_at).getTime()
    ))
    .map(mapSupportMessage)
)

export const mapSupportTicket = (ticket: SupportTicketListItem): SupportRequest => ({
  calculationNumber: ticket.calculation_number || undefined,
  category: ticket.category_display,
  createdAt: ticket.created_at,
  detailId: ticket.detail_id,
  id: ticket.id,
  isUnread: ticket.is_unread,
  lastMessage: ticket.last_message,
  lastMessageAuthor: ticket.last_message_author,
  messages: mapSupportMessages(ticket.messages),
  status: ticket.status,
  statusUpdatedAt: ticket.status_updated_at,
  step: ticket.step_display,
  subject: ticket.subject,
  supportLevel: ticket.support_level_display,
})

export const mapSupportTicketsResponse = (response: SupportTicketsResponse): SupportRequestsResponse => ({
  ...response,
  results: response.results.map(mapSupportTicket),
})
